import React, { Component } from 'react';
import ColButton from '../../../Elements/ColButton';
import InfoBox from '../../../Elements/InfoBox';
import PanelBorder from '../../../Elements/PanelBorder';
import InputWithClear from '../../../Elements/InputComponents/InputWithClear';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningStatusEnum from '../../../Enums/PlanningStatusEnum';
import statusHelper from '../../../Helpers/statusHelper';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ButtonFooterContainer from '../../../Elements/ButtonFooterContainer';

class PDMassStatusUpdate extends Component
{
  constructor (props)
  {
    super(props);
    const firstToValue = PlanningStatusEnum.ClientConfirmed;
    this.state = {
      info: statusHelper.getFromInfo(firstToValue),
      toSelectValues: statusHelper.getToSelectValues(firstToValue),
      to: firstToValue,
    };
    this.clickOnSubmit = this.clickOnSubmit.bind(this);
  }

  clickOnSubmit ()
  {
    if (this.state.to !== PlanningStatusEnum.Closed && this.state.to !== PlanningStatusEnum.Cancelled)
    {
      this.props.submitHandler(this.state.to);
      return;
    }

    ErrorMessage.SetApprove("You won't be able to go back. Are you sure?", () =>
      this.props.submitHandler(this.state.to)
    );
  }

  render ()
  {
    return (
      <PanelBorder
        headerText='PlanningDetail Mass Status Update'
        clickOnCancel={this.props.clickOnCancel}
        icon='fa-solid fa-pen-alt'
      >
        <form
          onSubmit={(e) =>
          {
            e.preventDefault();
            this.clickOnSubmit();
          }}
        >
          <div className='container-fluid '>
            <div className='row'>
              <div className='col'>
                <InfoBox
                  text={this.state.info}
                  title='From'
                  rotated='-'
                />
              </div>
              <div className='col hover rounded p-1'>
                <InputWithClear
                  labelText='To'
                  type={InputTypesEnum.Select}
                  selectValues={this.state.toSelectValues}
                  value={this.state.to}
                  onChange={(fieldName, newValue) =>
                  {
                    this.setState({
                      to: newValue,
                      info: statusHelper.getFromInfo(newValue),
                    });
                  }}
                />
              </div>
            </div>
          </div>
          <div className='m-3' />
          <ButtonFooterContainer>
            <ColButton
              text='Cancel'
              onClick={this.props.clickOnCancel}
            />
            <ColButton
              text='Ok'
              type='submit'
              icon='fa-solid fa-save'
            />
          </ButtonFooterContainer>
        </form>
      </PanelBorder>
    );
  }
}

export default PDMassStatusUpdate;
